import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_TEXT_CONTENT_SNIPPET = gql`
  mutation createTextContentSnippet($containerId: Int!, $visible: Boolean!, $text: String!, $title: String!) {
    contentSnippet {
      createContentSnippet(
        baseSnippet: { containerId: $containerId, visible: $visible, entityTitle: $title }
        contentSnippetText: { text: $text }
      ) {
        id
        sort
      }
    }
  }
`;

const createTextContentSnippetRequest = ({ containerId, isVisible, text, onError, onSuccessResult }) => (
  <Mutation mutation={CREATE_TEXT_CONTENT_SNIPPET}>
    {(createContentSnippet, { loading, error, data }) => {
      const variables = {
        containerId,
        visible: isVisible,
        text,
        title: '',
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentSnippet.createContentSnippet.id, data.contentSnippet.createContentSnippet.sort);
      }

      return <MutationRequest isLoading={loading} mutation={createContentSnippet} variables={variables} />;
    }}
  </Mutation>
);

createTextContentSnippetRequest.propTypes = {
  containerId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
};

createTextContentSnippetRequest.defaultProps = {
  isVisible: true,
};

export default createTextContentSnippetRequest;
